import {kmApiLink} from "@pg-mono/km-routes";

import axios from "../../km_app/utils/fetch";

export const cplUnsubscribeUser = (uuid: string) => {
    return axios.post(kmApiLink.unsubscribe.cpl.base(), {uuid});
};
import {kmApiLink} from "@pg-mono/km-routes";

import axios from "../../km_app/utils/fetch";

export const cplUnsubscribeUser = (uuid: string) => {
    return axios.post(kmApiLink.unsubscribe.cpl.base(), {uuid});
};
